import { useForm } from 'react-hook-form'
import { useEffect } from 'react'
import { ExaminationRoom } from '@/pages/clinic/examinationRooms/columns'
import { Button } from '@/components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { useAuth } from '@/hooks/useAuth'
import { examinationRoomService } from '@/services/examination_service'
import { toast } from 'sonner'

type FormValues = {
  name: string
  department: string
  is_active: boolean
  patient_flow_device_ip?: string
}

type InfoSettingProps = {
  examinationRoom?: ExaminationRoom
  isLoading?: boolean
  onSuccess?: () => void
}

export function InfoSetting({ examinationRoom, isLoading, onSuccess }: InfoSettingProps) {
  const { token } = useAuth()
  const form = useForm<FormValues>({
    // resolver: zodResolver(formSchema),
    defaultValues: {
      name: '',
      department: '',
      is_active: true,
      patient_flow_device_ip: '',
    },
  })

  // Update form values when examinationRoom data is loaded
  useEffect(() => {
    if (examinationRoom) {
      form.reset({
        name: examinationRoom.name ?? '',
        department: examinationRoom.department ?? '',
        is_active: examinationRoom.is_active ?? true,
        patient_flow_device_ip: examinationRoom.patient_flow_device_ip ?? '',
      })
    }
  }, [examinationRoom, form])

  const onSubmit = async (values: FormValues) => {
    if (!examinationRoom) return

    const response = await examinationRoomService.updateExaminationRoom(
      {
        examination_room_id: examinationRoom.examination_room_id,
        clinic_id: examinationRoom.clinic_id,
        name: values.name,
        department: values.department,
        is_active: values.is_active,
        patient_flow_device_ip: values.patient_flow_device_ip,
      },
      token ?? '',
    )

    if (response.success) {
      toast.success('更新診間基本資料成功')
      onSuccess?.()
    }
  }

  if (isLoading) {
    return <div>載入中...</div>
  }

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold tracking-tight">編輯基本資料</h2>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>診間名稱</FormLabel>
                <FormControl>
                  <Input placeholder="請輸入診間名稱" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="department"
            render={({ field }) => (
              <FormItem>
                <FormLabel>科別</FormLabel>
                <FormControl>
                  <Input placeholder="請輸入科別" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* <FormField
            control={form.control}
            name="patient_flow_device_ip"
            render={({ field }) => (
              <FormItem>
                <FormLabel>即時人流裝置 IP</FormLabel>
                <FormControl>
                  <Input placeholder="請輸入即時人流裝置 IP" {...field} />
                </FormControl>
                <FormDescription>例如: 192.168.1.100</FormDescription>
                <FormMessage />
              </FormItem>
            )}
          /> */}

          {/* <AdminOnly>
            <FormField
              control={form.control}
              name="is_active"
              render={({ field }) => (
                <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
                  <div className="space-y-0.5">
                    <FormLabel className="text-base">狀態</FormLabel>
                    <FormDescription>{field.value ? '啟用' : '停用'}</FormDescription>
                  </div>
                  <FormControl>
                    <Switch checked={field.value} onCheckedChange={field.onChange} />
                  </FormControl>
                </FormItem>
              )}
            />
          </AdminOnly> */}

          <Button type="submit">儲存</Button>
        </form>
      </Form>
    </div>
  )
}
